// React Imports
import { useEffect, useState } from "react";

// Router Imports
import { useNavigate } from "react-router-dom";

// Utils Imports
import { GlobalConfiguration } from "../../../utils/configurationProvider";

// Component Imports
import { useDispatch } from "react-redux";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import StatusContainer from "../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";

const ReimbursementTxnMultiApprovalSuccess = () => {
  // 1️⃣ useNavigate
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 2️⃣ useState
  const [successPageData, setsuccessPageData] = useState([]);
  const [successPageID, setsuccessPageID] = useState([]);
  const [pendingTransactions, setPendingTransactions] = useState([]);
  const [approvedTransactions, setApprovedTransactions] = useState([]);

  // 3️⃣ Callback / Handler functions
  const goToDashboard = () => {
    navigate("/reimbursement_transaction_dashboard", {
      replace: true,
    });
  };

  const buttonRows = [
    [
      {
        btnText: "Go to approval",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/view_all/go_to_approval_white_circle.svg",
        imgColor: "var(--positive-bg)",
        handleFunction: () => {
          navigate(
            "/reimbursement_transaction_dashboard/reimbursement_transaction_multi_approval",
            {
              replace: true,
            },
          );
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "black",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/view_all/go_to_dashboard.svg",
        imgColor: "var(--text-primary)",
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];

  // 4️⃣ useEffect
  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementTxnData"),
    );

    if (storedSelectedApproval) {
      const transactions =
        storedSelectedApproval?.selectedSendTransactions || [];
      const pending = transactions.filter(
        (transaction) => transaction.lifecycle_status === "pending",
      );
      const approved = transactions.filter(
        (transaction) => transaction.lifecycle_status === "approved",
      );
      setsuccessPageData(storedSelectedApproval?.selectedSendTransactions);
      setPendingTransactions(pending);
      setApprovedTransactions(approved);
      setsuccessPageID(storedSelectedApproval.selectedTransactions);
    } else {
      setsuccessPageData([]);
      setsuccessPageID([]);
    }
  }, []);
  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <>
      <StatusContainer
        status="success"
        title={successPageData.length && "Transactions approved successfully."}
        buttonRows={buttonRows}
      >
        {approvedTransactions.length > GlobalConfiguration.lengthCheckZero && (
          <TabsWeapperSection
            title={`Distribution created  - ${successPageID.length}`}
          >
            <div className="flex flex-col">
              {successPageData.map((account, i) => (
                <InfoCard
                  key={account?.txn_id || i}
                  bgColor="var(--positive-card)"
                  hoverable="black"
                  onClick={() =>
                    navigate(
                      `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                      {
                        replace: true,
                      },
                    )
                  }
                  showRowDivider
                  rowBorderColor={"var(--positive-bg)"}
                  rows={[
                    {
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "semibold",
                      rightIcon: true,
                      leftTitle: `INR ${FormatAmount({ price: account?.amount })}`,
                      leftSubTitle: "Amount",
                      onClick: () =>
                        navigate(
                          `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                          {
                            replace: true,
                          },
                        ),
                    },
                    {
                      leftTitle: account?.beneficiary_account_name,
                      leftSubTitle: "Account name",
                    },
                  ]}
                />
              ))}
            </div>
          </TabsWeapperSection>
        )}

        {pendingTransactions.length > GlobalConfiguration.lengthCheckZero && (
          <TabsWeapperSection
            title={`Pending  - ${pendingTransactions.length}`}
          >
            <div className="flex flex-col">
              {successPageData.map((account, i) => (
                <InfoCard
                  key={account?.txn_id || i}
                  bgColor="var(--positive-card)"
                  hoverable="black"
                  onClick={() =>
                    navigate(
                      `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                      {
                        replace: true,
                      },
                    )
                  }
                  showRowDivider
                  rowBorderColor={"var(--positive-bg)"}
                  rows={[
                    {
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "semibold",
                      rightIcon: true,
                      leftTitle: `INR ${FormatAmount({ price: account?.amount })}`,
                      leftSubTitle: "Amount",
                      onClick: () =>
                        navigate(
                          `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                          {
                            replace: true,
                          },
                        ),
                    },
                    {
                      leftTitle: account?.beneficiary_account_name,
                      leftSubTitle: "Account name",
                    },
                  ]}
                />
              ))}
            </div>
          </TabsWeapperSection>
        )}

        {pendingTransactions.length > GlobalConfiguration.lengthCheckZero &&
          approvedTransactions.length > GlobalConfiguration.lengthCheckZero && (
            <>
              <TabsWeapperSection
                title={`Distribution created   - ${approvedTransactions?.length}`}
              >
                <div className="flex flex-col">
                  {successPageData.map((account, i) => (
                    <InfoCard
                      key={account?.txn_id || i}
                      bgColor="var(--positive-card)"
                      hoverable="black"
                      onClick={() =>
                        navigate(
                          `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                          {
                            replace: true,
                          },
                        )
                      }
                      showRowDivider
                      rowBorderColor={"var(--positive-bg)"}
                      rows={[
                        {
                          rightTitleTextColor: "var(--text-primary)",
                          rightTextFontWeight: "semibold",
                          rightIcon: true,
                          leftTitle: `INR ${FormatAmount({ price: account?.amount })}`,
                          leftSubTitle: "Amount",
                          onClick: () =>
                            navigate(
                              `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                              {
                                replace: true,
                              },
                            ),
                        },
                        {
                          leftTitle: account?.beneficiary_account_name,
                          leftSubTitle: "Account name",
                        },
                      ]}
                    />
                  ))}
                </div>
              </TabsWeapperSection>
              <TabsWeapperSection
                title={`Pending  - ${pendingTransactions?.length}`}
              >
                <div className="flex flex-col">
                  {successPageData.map((account, i) => (
                    <InfoCard
                      key={account?.txn_id || i}
                      bgColor="var(--positive-card)"
                      hoverable="black"
                      onClick={() =>
                        navigate(
                          `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                          {
                            replace: true,
                          },
                        )
                      }
                      showRowDivider
                      rowBorderColor={"var(--positive-bg)"}
                      rows={[
                        {
                          rightTitleTextColor: "var(--text-primary)",
                          rightTextFontWeight: "semibold",
                          rightIcon: true,
                          leftTitle: `INR ${FormatAmount({ price: account?.amount })}`,
                          leftSubTitle: "Amount",
                          onClick: () =>
                            navigate(
                              `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                              {
                                replace: true,
                              },
                            ),
                        },
                        {
                          leftTitle: account?.beneficiary_account_name,
                          leftSubTitle: "Account name",
                        },
                      ]}
                    />
                  ))}
                </div>
              </TabsWeapperSection>
            </>
          )}
      </StatusContainer>
    </>
  );
};

export default ReimbursementTxnMultiApprovalSuccess;
